import { Theme } from '@freighthub/silhouette-core'

export const getHoverColor = (theme: Theme) => theme.palette.grey[700]
